import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useState } from 'react';
import { Row, Col, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import { omit } from 'lodash';
import { IconPlusCircleOutline } from '@sfx/icons';
import { validatePhoneNumber } from '../../utils/formValidation';
import CommonSelect from '../../../Basic/Select';

var NumberInputDom = function NumberInputDom(props) {
  var onChange = props.onChange;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      validateMsg = _useState2[0],
      setValidateMsg = _useState2[1];

  var inputProps = omit(props, 'type', 'maxLength');

  var onNumberChange = function onNumberChange(e) {
    var value = e.target.value;
    var validateRes = validatePhoneNumber(value);
    var msg = " Please only use + , - , ( ) , . , and spaces to divide phone numbers in\n          this section.";
    setValidateMsg(validateRes.valid ? '' : msg);

    if (onChange) {
      onChange(e, validateRes);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    for: "name"
  }, props.label), props.required && (props.value || !props.value.trim()) && /*#__PURE__*/React.createElement("span", {
    className: "".concat(props.prefix, "-require")
  }, "*"), /*#__PURE__*/React.createElement(Input, _extends({}, inputProps, {
    onChange: onNumberChange
  }))), /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#ee3a2e'
    }
  }, validateMsg));
};

var InputDom = function InputDom(props) {
  return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    for: "name"
  }, props.label), props.required && (!props.value || !props.value.trim()) && /*#__PURE__*/React.createElement("span", {
    className: "".concat(props.prefix, "-require")
  }, "*"), /*#__PURE__*/React.createElement(Input, omit(props, 'type', 'maxLength')));
};

var SelectDom = function SelectDom(props) {
  return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    for: "province"
  }, props.label), props.required && !props.value && /*#__PURE__*/React.createElement("span", {
    className: "".concat(props.prefix, "-require")
  }, "*"), /*#__PURE__*/React.createElement(CommonSelect, props));
};

var AddLabelDom = function AddLabelDom(props) {
  return /*#__PURE__*/React.createElement("span", {
    onClick: props.onClick
  }, /*#__PURE__*/React.createElement(IconPlusCircleOutline, {
    size: "18"
  }), "\xA0 ", props.label);
};

var EditForm = function EditForm(props) {
  var prefix = props.prefix,
      formItemList = props.formItemList,
      saveButtonText = props.saveButtonText,
      cancelButtonText = props.cancelButtonText,
      onSave = props.onSave,
      onCancel = props.onCancel,
      currentObject = props.currentObject,
      updateCurrentObject = props.updateCurrentObject;

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isDisabled = _useState4[0],
      setIsDisabled = _useState4[1];

  var _useState5 = useState({
    valid: true
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      validateRes = _useState6[0],
      setValidateRes = _useState6[1];

  var onInputChange = function onInputChange(e, validateRes) {
    var _e$target = e.target,
        name = _e$target.name,
        value = _e$target.value;

    var obj = _objectSpread(_objectSpread({}, currentObject), {}, _defineProperty({}, name, value));

    updateCurrentObject(obj);

    if (validateRes) {
      setValidateRes(validateRes);
    }
  };

  var onSelectChange = function onSelectChange(item, name, relatedName) {
    var _objectSpread3;

    if (!name) {
      return;
    }

    var obj = relatedName ? _objectSpread(_objectSpread({}, currentObject), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, name, item), _defineProperty(_objectSpread3, relatedName, null), _objectSpread3)) : _objectSpread(_objectSpread({}, currentObject), {}, _defineProperty({}, name, item));
    updateCurrentObject(obj);
  };

  useEffect(function () {
    var _validateRes$valid = validateRes.valid,
        valid = _validateRes$valid === void 0 ? true : _validateRes$valid;
    var isDisabled = !valid;

    if (valid) {
      isDisabled = formItemList.filter(function (i) {
        return i.required && i.visible;
      }).some(function (i) {
        var value = currentObject[i.item.name];

        if (value === null) {
          return true;
        } else {
          return !value;
        }
      });
    }

    setIsDisabled(isDisabled);
  }, [formItemList, currentObject, validateRes]);

  var onAddLabelClick = function onAddLabelClick(props) {
    var obj = _objectSpread(_objectSpread({}, currentObject), {}, _defineProperty({}, props.name, props.type));

    updateCurrentObject(obj);
  };

  var EditFormItemDom = function EditFormItemDom(props) {
    var item = props.item,
        required = props.required;
    var type = item.type,
        name = item.name,
        relatedName = item.relatedName;

    switch (type) {
      case 'phoneNum':
        return /*#__PURE__*/React.createElement(Col, {
          md: "6",
          key: name
        }, /*#__PURE__*/React.createElement(NumberInputDom, _extends({}, item, {
          prefix: prefix,
          value: currentObject[name] || '',
          onChange: onInputChange,
          required: required
        })));

      case 'text':
        return /*#__PURE__*/React.createElement(Col, {
          md: "6",
          key: name
        }, /*#__PURE__*/React.createElement(InputDom, _extends({}, item, {
          prefix: prefix,
          value: currentObject[name] || '',
          onChange: onInputChange,
          required: required
        })));

      case 'select':
        return /*#__PURE__*/React.createElement(Col, {
          md: "6",
          key: name
        }, /*#__PURE__*/React.createElement(SelectDom, _extends({}, item, {
          value: currentObject[name],
          prefix: prefix,
          onChange: function onChange(item) {
            return onSelectChange(item, name, relatedName);
          },
          required: required
        })));

      case 'add':
        return /*#__PURE__*/React.createElement(Col, {
          md: "6",
          key: name,
          className: "".concat(prefix, "-form-icon")
        }, /*#__PURE__*/React.createElement(AddLabelDom, _extends({}, item, {
          prefix: prefix,
          onClick: function onClick() {
            return onAddLabelClick(item);
          },
          required: required
        })));

      default:
        break;
    }
  };

  return /*#__PURE__*/React.createElement(Form, {
    className: "".concat(prefix, "-form")
  }, /*#__PURE__*/React.createElement(Row, null, formItemList.map(function (i) {
    return i.visible ? EditFormItemDom(i) : null;
  }), /*#__PURE__*/React.createElement(Col, {
    xs: "12",
    style: {
      textAlign: 'right'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    onClick: onCancel
  }, cancelButtonText), /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    color: "primary",
    style: {
      marginLeft: '20px'
    },
    disabled: isDisabled,
    onClick: onSave
  }, saveButtonText))));
};

export default EditForm;